var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.link.length)?_c('v-btn',{attrs:{"color":"primary","disabled":!_vm.link.length},on:{"click":function($event){return _vm.openLink(_vm.link)}}},[_vm._v(" Ficha tecnica ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }